// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"a30c5aee","787":"e058ae7c"}[chunkId] + ".chunk.js";
};